import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Gift, Copy, Share2, DollarSign, ArrowRight } from 'lucide-react';

export const DashboardReferral = ({ referralData, loadingReferral, referralLink, copyReferralLink, shareReferralWhatsApp, theme, companyId }) => {
  const { dm, cardBg, textPrimary, textSecondary, textMuted } = theme;

  return (
    <Card className={`rounded-xl border shadow-sm mb-6 ${cardBg} transition-colors duration-300 overflow-hidden`} data-testid="referral-card">
      <div className={`px-6 py-4 ${dm ? 'bg-gradient-to-r from-[#C5A059]/20 to-transparent' : 'bg-gradient-to-r from-[#C5A059]/10 to-transparent'}`}>
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-[#C5A059]/20 flex items-center justify-center">
            <Gift className="w-5 h-5 text-[#C5A059]" />
          </div>
          <div>
            <h3 className={`text-base font-semibold ${textPrimary}`}>Indique e Ganhe</h3>
            <p className={`text-xs ${textSecondary}`}>Indique empresas e ganhe desconto na sua fatura</p>
          </div>
        </div>
      </div>
      <CardContent className="pt-4">
        {loadingReferral ? (
          <div className="flex justify-center py-6">
            <div className="animate-spin w-6 h-6 border-2 border-[#C5A059] border-t-transparent rounded-full" />
          </div>
        ) : referralData ? (
          <div className="space-y-4">
            <div>
              <label className={`text-xs font-medium ${textSecondary} block mb-1.5`}>Seu link exclusivo de indicacao:</label>
              <div className="flex gap-2">
                <div className={`flex-1 h-10 px-3 flex items-center rounded-lg text-sm font-mono truncate ${dm ? 'bg-slate-800 text-slate-300 border border-slate-700' : 'bg-slate-50 text-slate-700 border border-slate-200'}`} data-testid="referral-link-display">
                  {referralLink}
                </div>
                <button onClick={copyReferralLink} className="h-10 px-3 rounded-lg bg-[#0A2647] text-white hover:bg-[#0A2647]/90 transition-colors flex items-center gap-1.5 text-sm font-medium" data-testid="referral-copy-btn">
                  <Copy className="w-4 h-4" />Copiar
                </button>
                <button onClick={shareReferralWhatsApp} className="h-10 px-3 rounded-lg bg-emerald-600 text-white hover:bg-emerald-700 transition-colors flex items-center gap-1.5 text-sm font-medium" data-testid="referral-whatsapp-btn">
                  <Share2 className="w-4 h-4" />WhatsApp
                </button>
              </div>
            </div>
            <div className={`p-3 rounded-xl text-xs ${dm ? 'bg-slate-800/50 text-slate-400' : 'bg-[#C5A059]/5 text-slate-600'}`}>
              <p className="font-semibold text-[#C5A059] mb-1">Como funciona?</p>
              <p>Quando uma empresa se cadastra pelo seu link e paga a primeira mensalidade, você ganha <strong>100% do valor como credito</strong>, dividido em 2 faturas (50% cada).</p>
            </div>
            <div className="grid grid-cols-3 gap-3">
              <div className={`text-center p-3 rounded-xl ${dm ? 'bg-slate-800' : 'bg-slate-50'}`}>
                <p className={`text-lg font-bold ${textPrimary}`} data-testid="referral-count">{referralData.referral_count}</p>
                <p className={`text-[11px] ${textMuted}`}>Indicados</p>
              </div>
              <div className={`text-center p-3 rounded-xl ${dm ? 'bg-slate-800' : 'bg-slate-50'}`}>
                <p className="text-lg font-bold text-emerald-500" data-testid="referral-applied">R$ {(referralData.summary?.total_applied || 0).toFixed(2).replace('.', ',')}</p>
                <p className={`text-[11px] ${textMuted}`}>Aplicado</p>
              </div>
              <div className={`text-center p-3 rounded-xl ${dm ? 'bg-slate-800' : 'bg-slate-50'}`}>
                <p className="text-lg font-bold text-amber-500" data-testid="referral-pending">R$ {(referralData.summary?.total_pending || 0).toFixed(2).replace('.', ',')}</p>
                <p className={`text-[11px] ${textMuted}`}>Pendente</p>
              </div>
            </div>
            {referralData.credits?.length > 0 && (
              <div>
                <p className={`text-xs font-semibold ${textSecondary} mb-2`}>Historico de Creditos</p>
                <div className="space-y-2">
                  {referralData.credits.map(c => (
                    <div key={c.id} className={`p-3 rounded-lg border ${dm ? 'border-slate-700 bg-slate-800/50' : 'border-slate-100'} text-sm`}>
                      <div className="flex items-center justify-between mb-1">
                        <span className={`font-medium ${textPrimary}`}>{c.referred_company_name}</span>
                        <span className="text-xs font-bold text-[#C5A059]">R$ {c.total_amount?.toFixed(2).replace('.', ',')}</span>
                      </div>
                      <div className="flex gap-3 text-xs">
                        <span className={c.credit_1?.status === 'applied' ? 'text-emerald-500' : 'text-amber-500'}>
                          1a: R$ {c.credit_1?.amount?.toFixed(2).replace('.', ',')} ({c.credit_1?.status === 'applied' ? 'Aplicado' : 'Pendente'})
                        </span>
                        <span className={c.credit_2?.status === 'applied' ? 'text-emerald-500' : 'text-amber-500'}>
                          2a: R$ {c.credit_2?.amount?.toFixed(2).replace('.', ',')} ({c.credit_2?.status === 'applied' ? 'Aplicado' : c.credit_2?.status === 'scheduled' ? 'Agendado' : 'Pendente'})
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        ) : (
          <p className={`text-sm ${textMuted} text-center py-4`}>Carregando...</p>
        )}

        {/* Upgrade: Virar Afiliado oficial (recebe PIX em vez de credito) */}
        {companyId && (
          <div className={`mt-5 pt-5 border-t ${dm ? 'border-slate-700/50' : 'border-slate-200'}`}>
            <div className={`p-4 rounded-xl bg-gradient-to-br ${dm ? 'from-emerald-900/30 to-emerald-800/10 border border-emerald-700/30' : 'from-emerald-50 to-emerald-100/40 border border-emerald-200'}`}>
              <div className="flex items-start gap-3 mb-3">
                <div className="w-9 h-9 rounded-lg bg-emerald-500/20 flex items-center justify-center flex-shrink-0">
                  <DollarSign className="w-4 h-4 text-emerald-500" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className={`text-sm font-bold ${textPrimary}`}>Tem mais de uma loja? Ganhe dinheiro com cada nova filial.</p>
                  <p className={`text-xs ${textSecondary} leading-relaxed mt-0.5`}>
                    Vire <strong>afiliado oficial</strong> e receba de <strong className="text-emerald-600">R$ 50 a R$ 250 via PIX</strong> por cada filial sua, sócio ou amigo lojista que assinar o Falo com o Dono. Sem limite de indicações.
                  </p>
                </div>
              </div>
              <Link to={`/afiliados?convite=${companyId}`} className="block">
                <Button className="w-full bg-emerald-600 hover:bg-emerald-700 text-white font-semibold h-11 text-sm gap-2" data-testid="become-affiliate-btn">
                  Quero virar afiliado <ArrowRight className="w-4 h-4" />
                </Button>
              </Link>
              <p className={`text-[10px] ${textMuted} text-center mt-2`}>Cadastro 1-clique · comissão paga em até 7 dias úteis</p>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
